module.exports = __webpack_public_path__ + "static/media/trainschedulerTextImage.5b7d8eea.png";